import Vue from 'vue';
import components from './components.js'
import { setupValidation } from './domain/validation/validation'
setupValidation()
const app = new Vue({
  el: '#app',
  data: {
    message: 'new js OMC'
  },
  components: components
})
